import { combineReducers } from 'redux'

import anexosDetalhesPrestacao from './anexosDetalhesPrestacao'

export default combineReducers({ anexosDetalhesPrestacao })
